<template>
  <overlay id="FolderSettingsOverlay">
    <page>
      <div class="content-filter__header">
        <div class="content-filter__foldername">{{ folder.name }}</div>
        <h1
          v-t="'c.folderSettingsOverlay.title'"
          class="content-filter__headline"
        />
      </div>

      <hr>

      <form-wrap @submit="handleSubmit">
        <form-field-set :should-show-border="false">
          <text-input
            v-model="name"
            :error="fieldError(requestType, 'name')"
            :label="$t('c.folderSettingsOverlay.form.label.name')"
            direction="vertical"
            name="name"
          />
          <text-area-input
            v-model="description"
            :error="fieldError(requestType, 'description')"
            :label="$t('c.folderSettingsOverlay.form.label.description')"
            direction="vertical"
            name="description"
          />
        </form-field-set>

        <form-field-set :should-show-border="false">
          <switch-input
            v-model="exportEnabled"
            :error="fieldError(requestType, 'exportEnabled')"
            :label="$t('c.folderSettingsOverlay.form.label.exportEnabled')"
            name="exportEnabled"
            direction="vertical"
          />

          <text-input
            v-if="exportEnabled"
            :is-copyable="true"
            :is-disabled="true"
            :value="exportUrl"
            :label="$t('c.folderSettingsOverlay.form.label.exportUrl')"
            :hint="$t('c.folderSettingsOverlay.form.label.exportUrlHint')"
            direction="vertical"
            name="exportUrl"
          />
        </form-field-set>

        <form-actions>
          <button-input
            :is-disabled="!isSaveable"
            @click="handleSubmit"
          >
            Speichern
          </button-input>
          <a
            class="cancel"
            @click="closeOverlay()"
          >
            Abbrechen
          </a>
        </form-actions>
      </form-wrap>
    </page>
  </overlay>
</template>

<script>
import isBlank from 'is-blank'
import { mapActions, mapState, mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import Overlay from '@/components/ui/Overlay'
import PageMixin from '@/mixins/pages/Page'
import FormMixin from '@/mixins/forms/Form'

export default {
  name: 'FolderSettingsOverlay',
  mixins: [PageMixin, FormMixin],
  components: {
    Overlay
  },
  computed: {
    ...mapGetters({
      fieldError: 'folderForm/fieldError',
      isSaveable: 'folderForm/isSaveable'
    }),
    ...mapState({
      folder: state => state.folder.folder
    }),
    requestType () {
      return 'update'
    },
    id: {
      get () { return this.$store.state.folderForm.form.id },
      set (value) { this.$store.dispatch('folderForm/setId', value) }
    },
    name: {
      get () { return this.$store.state.folderForm.form.name },
      set (value) { this.$store.dispatch('folderForm/setName', value) }
    },
    description: {
      get () { return this.$store.state.folderForm.form.description },
      set (value) { this.$store.dispatch('folderForm/setDescription', value) }
    },
    exportEnabled: {
      get () { return this.$store.state.folderForm.form.exportEnabled },
      set (value) { this.$store.dispatch('folderForm/setExportEnabled', value) }
    },
    exportUrl () {
      return this.$store.state.folder.folder.export.url;
    }
  },
  methods: {
    ...mapActions({
      openOverlay: 'openOverlay',
      closeOverlay: 'closeOverlay',
      customSubmit: 'folderForm/customSubmit',
      fetchFolder: 'fetchFolder'
    }),
    handleSubmit () {
      const folderId = this.$route.params.folderId

      this.customSubmit()
        .then(() => {
          return Promise.all([
            this.fetchFolder(folderId)
          ])
        })
        .then(this.closeOverlay)
    }
  },
  created () {
    const folderId = this.$route.params.folderId
    this.$store.dispatch('folderForm/show', { folderId }, { root: true })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/folders/FolderSettingsOverlay.vue